export function translate(text, fallback = null) {
	//TODO: Do translation
	return text;

	//TODO: If translation fails, use fallback if provided or else use the non-translated text
	if (fallback != null)
	return text;
}
